import { triggerMomentary, type InstrumentPlayerProps } from "../playerTypes";

const dayanZones = ["kinar", "chanti", "maidan", "syahi"];

export function TablaPlayer(props: InstrumentPlayerProps) {
  return (
    <div className="instrument-ui tabla-ui" data-testid="instrument-player-tabla">
      <div className="tabla-pair" aria-label="Tabla dayan and bayan pair">
        <section className="tabla-drum dayan" aria-label="Dayan with center or near-center syahi" data-control-target="tabla-dayan-zones">
          <span className="syahi center" />
          {dayanZones.map((zone) => (
            <button key={zone} type="button" className={`tabla-zone zone-${zone}`} aria-label={`Play dayan ${zone} zone`} onClick={() => triggerMomentary(props, "E4", `dayan_${zone}`, 0.76, 170)}>
              {zone}
            </button>
          ))}
        </section>
        <section className="tabla-drum bayan" aria-label="Bayan with offset syahi">
          <span className="syahi offset" />
          <button type="button" className="tabla-zone pressure-zone" aria-label="Play tabla bayan pressure zone" onClick={() => triggerMomentary(props, "C4", "bayan_pressure", 0.84, 260)}>
            pressure zone
          </button>
        </section>
      </div>
      <div className="instrument-control-strip">
        <label className="surface-slider" data-control-target="tabla-bayan-pressure"><span>Bayan pressure</span><input aria-label="Tabla bayan pressure" data-testid="tabla-bayan-pressure-slider" type="range" min="0" max="1" step="0.01" defaultValue="0" onInput={(event) => props.onControl("bayan_pressure", Number(event.currentTarget.value))} /></label>
      </div>
      <p className="instrument-note">Bayan pressure press raises pitch; release falls back to base.</p>
    </div>
  );
}
